import { Navigate, useParams } from 'react-router'

/**
 * EntityRedirect
 *
 * Redirects all users to the Dashboard when navigating to an entity.
 */
const EntityRedirect = () => {
  const { entityId } = useParams()

  return <Navigate replace to={`/accounts/${entityId}/dashboard`} />
}

export default EntityRedirect
